/**
 * Tên vai trò / phòng ban theo dữ liệu (05/11/2026): vai trò, phòng ban thêm mới (VD khi nhập Excel nhân sự)
 * không có trong nhãn cố định của màn nhân sự — hiện tên đã lưu thay vì mã.
 */
import { useQuery } from '@tanstack/react-query';
import { trpcClient } from '@/lib/trpc';

const roleNames = new Map<string, string>();
const deptNames = new Map<string, string>();
const list = (res: any): any[] => (Array.isArray(res) ? res : res?.items || res?.data || []);

export const knownRoleName = (code?: string | null) => (code ? roleNames.get(code.toUpperCase()) : undefined);
export const knownDepartmentName = (code?: string | null) => (code ? deptNames.get(code.toUpperCase()) : undefined);

/** Nạp tên vai trò / phòng ban; component dùng hook sẽ vẽ lại khi có dữ liệu */
export function useOrgNames() {
  return useQuery({
    queryKey: ['org-names'],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const [roles, depts] = await Promise.all([
        trpcClient.roles.list.query().catch(() => []),
        trpcClient.users.getDepartments.query().catch(() => []),
      ]);
      list(roles).forEach((r: any) => r?.roleId && r?.name && roleNames.set(String(r.roleId).toUpperCase(), r.name));
      list(depts).forEach((d: any) => d?.code && d?.name && deptNames.set(String(d.code).toUpperCase(), d.name));
      return { roles: roleNames.size, departments: deptNames.size };
    },
  });
}
